









































import 'vue-json-viewer/style.css'
import JsonViewer from 'vue-json-viewer'
import {Component, Prop, Vue} from "vue-property-decorator";
import OverViewTable from "@/valchrom/views/dataset/OverViewTable.vue";
import DevAMContent from "@/valchrom/views/dataset/DevAMContent.vue";
import CalBlanksContent from "@/valchrom/views/dataset/am/CalBlanksContent.vue";
import CCACCBContent from "@/valchrom/views/dataset/am/CCACCBContent.vue";
import SD6Spike from "@/valchrom/views/dataset/am/SD6Spike.vue";
import CalRes from "@/valchrom/views/dataset/am/CalRes.vue";
import MissingAMContent from "@/valchrom/views/dataset/MissingAMContent.vue";
import CalYContent from "@/valchrom/views/dataset/am/CalYContent.vue";
import AM362Content from "@/valchrom/views/dataset/am/AM362Content.vue";
import MZContent from "@/valchrom/views/dataset/am/MZContent.vue";
import UploadPicContent from "@/valchrom/views/dataset/am/UploadPicContent.vue";
import RSContent from "@/valchrom/views/dataset/am/RSContent.vue";
import AM351Content from "@/valchrom/views/dataset/am/AM351Content.vue";
import AM341Content from "@/valchrom/views/dataset/am/AM341Content.vue";
import UploadVisualContent from "@/valchrom/views/dataset/am/UploadVisualContent.vue";
import CCACCBHeteroContent from "@/valchrom/views/dataset/am/CCACCBHeteroContent.vue";
import DecisonIconButtonComponent from "@/components/features/buttons/DecisonIconButtonComponent.vue";
import CriteriaTable from "@/valchrom/views/dataset/CriteriaTable.vue";
import {Getter} from "vuex-class";

@Component({
    components: {
        CriteriaTable,
        OverViewTable,
        JsonViewer,
        MissingAMContent,
        DevAMContent,
        DecisonIconButtonComponent,
        SD6Spike,
        CalRes,
        CalBlanksContent,
        CalYContent,
        CCACCBContent,
        AM362Content,
        MZContent,
        UploadPicContent,
        RSContent,
        AM351Content,
        AM341Content,
        UploadVisualContent,
        CCACCBHeteroContent
    }
})
export default class AmView extends Vue {
    name = 'AmView';
    AmView = AmView;
    @Prop() am: any;
    @Prop() code: any;
    @Prop() analyte: any;

    @Getter overview_simplify !: boolean;

    isDev(){
        return process.env.NODE_ENV === 'development' && !this.overview_simplify
    }

    public static hasData(am:any) {
        if(am.code == "upload_vis") {
            return am.am_data.series_none.marker_none.images;
        }
        if(am.code == "m_z") {
            return am.am_data.series;
        }
        if(am.code == "rs") {
            return am.am_data.series;
        }
        if(am.code == "upload_pic") {
            return am.am_data.series_none.marker_none.images;
        }
        if(am.code == "upload_s_n") {
            return am.am_data.series_none.marker_none.table;
        }

        for(let data_row of am.am_data.series_none.marker_none.dict.data){
            if(data_row.n && data_row.n > 0){
                return true;
            }
        }
        return  false;
    }

    getAMContent(am:any) {
        if(am.code == "cal_blanks"){
            return "CalBlanksContent"
        }
        if(am.code == "cca_ccb_homo"){
            return "CCACCBContent"
        }
        if(am.code == "cca_ccb_hetero"){
            return "CCACCBHeteroContent"
        }

        if(am.code == "sd_6spike") {
            return "SD6Spike"
        }

        if(am.code == "cal_res") {
            return "CalRes"
        }

        if(am.code == "1_5_1") {
            return "AM351Content"
        }

        if(am.code == "3_6_2") {
            return "AM362Content"
        }

        if(am.code == "cal_y") {
            return "CalYContent"
        }

        if(am.code == "m_z") {
            return "MZContent"
        }

        if(am.code == "upload_pic") {
            return "UploadPicContent"
        }

        if(am.code == "upload_pic") {
            return "UploadPicContent"
        }

        if(am.code == "rs") {
            return "RSContent"
        }

        if(am.code == "3_5_1"){
            return "AM351Content"
        }

        if(am.code == "2_6_1"){
            return "AM351Content"
        }

        if(am.code == "1_6_1"){
            return "AM351Content"
        }

        if(am.code == "1_5_3"){
            return "AM351Content"
        }

        if(am.code == "3_4_1") {
            return "AM341Content"
        }

        if(am.code == "1_1_10") {
            return "AM341Content"
        }
        if(am.code == "ref_samp") {
            return "AM341Content"
        }

        if(am.code == "ref_method"){
            return "AM341Content"
        }

        if(am.code == "1_4_5"){
            return "AM341Content"
        }
        if(am.code == "1_3_3"){
            return "AM341Content"
        }
        if(am.code == "1_1_6"){
            return "AM341Content"
        }

        if(am.code == "2_1_6"){
            return "AM341Content"
        }

        if(am.code == "2_3_3"){
            return "AM341Content"
        }

        if(am.code == "upload_s_n") {
            return "UploadVisualContent"
        }

        if(am.code == "upload_vis"){
            return "UploadVisualContent"
        }

        return "MissingAMContent"
    }
}
